export const capitalize = <T extends string>(value: T) =>
  `${value.charAt(0).toUpperCase()}${value.slice(1).toLowerCase()}` as Capitalize<Lowercase<T>>;

export const capitalizeOnly = <T extends string>(value: T) =>
  `${value.charAt(0).toUpperCase()}${value.slice(1)}` as Capitalize<T>;

export const capitalizeEach = (value: string) =>
  value
    .split(' ')
    .map(word => `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`)
    .join(' ');

export const trimAsterisk = (value: string) => value.replace(/\*$/, '');

// Checks whether the string is just an empty string (as opposed to null or undefined)
export const isEmptyString = (value: string) => typeof value === 'string' && value.trim() === '';

export const escapeHTML = (str: string) =>
  str.replace(
    /[&<>'"]/g,
    tag =>
      ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;',
      })[tag] || tag
  );

export const unescapeHTML = (str: string) =>
  str.replace(
    /&amp;|&lt;|&gt;|&#39;|&quot;/g,
    tag =>
      ({
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&#39;': "'",
        '&quot;': '"',
      })[tag] || tag
  );
